import { Component, OnInit, inject } from '@angular/core';
import { AppConfig } from '../../appconfig';
import { RBCheck } from '@ldw/roesberg';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { LdwRouterService } from '../../route/ldw-router.service';
import { SettingsService } from '../../shared/settings/settings.service';
import { WebdokuService } from '../../web-doku/webdoku.service';

@Component({
    selector: 'ldw-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.css'],
    standalone: false
})
export class ErrorPageComponent implements OnInit {
  private config = inject(AppConfig);
  private route = inject(ActivatedRoute);
  private translate = inject(TranslateService);
  private routerService = inject(LdwRouterService);
  private webDokuService = inject(WebdokuService);
  private settingsService = inject(SettingsService);

  public longVersion = '';
  public errorText = '';
  public backVisible = false;

  ngOnInit(): void {
    this.longVersion = 'Version ' + this.config.version();
    this.errorText = this.config.fatalError;
    const error = this.webDokuService.webDokuSelectErrorCode || this.route.snapshot.paramMap.get('error');

    if (!RBCheck.isNullOrEmpty(error)) {
      this.errorText = this.translate.instant('ERROR.' + error);
      this.backVisible = true;
    }
  }
  goBack(event: any) {
    this.routerService.navigateBack();
  }

  showToolTip(): boolean {
    return this.settingsService.settings.viewMode.showTooltips;
  }
}
